<template>
    <div
      class="modal right fade trader-info"
      id="trader-info"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"       
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" >{{type}} CONCENTRATION</h5>
            <button type="button" class="close"  @click="$emit('close')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="table-responsive" v-if="type == 'STATE'">
                <table class="table align-items-center table-flush table-hover bidtbl">
                    <thead class="thead-light psticky">
                        <tr>
                            <th scope="col" class="sort text-center">STATE</th>
                            <th scope="col" class="sort text-center">VALUE(%)</th>
                            <th scope="col" class="sort text-center">DOLLAR AMOUNT</th>
                            <th scope="col" class="sort text-center">Bought Today</th>
                            <th scope="col" class="sort text-center">IMS CAPITAL</th>
                            <th scope="col" class="sort text-center">AT RISK</th>
                        </tr>
                    </thead>
                    <tbody class="list no-cursor">
                        <tr v-for="(stateData) in traderData.stateConcList" :key="stateData.concentration">
                                <td class="text-center">{{ stateData.concentration }}</td>
                                <td class="text-center">{{ stateData.concentrationValue }}</td>
                                <td class="text-center">{{ stateData.concentrationValueDolAmt  | currency }}</td>
                                <td class="text-center">{{ stateData.capitalInvestedDolAmt  | currency }}</td>
                                <td class="text-center">{{ stateData.invOfferDolAmt  | currency }}</td>
                                <td class="text-center">{{ stateData.capitalAtRisk  | currency }}</td>
                            </tr>
                        </tbody>
                    </table>
            </div>
            <div class="table-responsive" v-if="type == 'RATING'">
                <table class="table align-items-center table-flush table-hover bidtbl">
                    <thead class="thead-light psticky">
                        <tr>
                            <th scope="col" class="sort text-center">RATING</th>
                            <th scope="col" class="sort text-center">VALUE(%)</th>
                            <th scope="col" class="sort text-center">DOLLAR AMOUNT</th>
                            <th scope="col" class="sort text-center">Bought Today</th>
                            <th scope="col" class="sort text-center">IMS CAPITAL</th>
                            <th scope="col" class="sort text-center">AT RISK</th>
                        </tr>
                    </thead>
                    <tbody class="list no-cursor">
                        <tr v-for="(ratingData) in traderData.creditRatingConcList" :key="ratingData.concentration">
                                <td class="text-center">{{ ratingData.concentration }}</td>
                                <td class="text-center">{{ ratingData.concentrationValue }}</td>
                                <td class="text-center">{{ ratingData.concentrationValueDolAmt  | currency }}</td>
                                <td class="text-center">{{ ratingData.capitalInvestedDolAmt  | currency }}</td>
                                <td class="text-center">{{ ratingData.invOfferDolAmt  | currency }}</td>
                                <td class="text-center">{{ ratingData.capitalAtRisk  | currency }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    export default {
        name: 'offeringImportmodal',
        components :{
            
        },
        props :["traderData","type"],
        data() {
            return {
                bidWanted : null
            };
        },
        methods: {
         
        },
        created: function() {
          console.log(this.traderData,this.type)
        }
    };
    </script>